import Modal, { ModalGlass } from "../../components/modal";

export default function PartnershipPage() {
  return (
    <div
      style={{
        backgroundImage:
          "url(https://static.igem.wiki/teams/4260/wiki/imagen/team/partnership/fondo-partnership.png)",
        minHeight: "100vh",
      }}
    >
      <div className="h-full w-full py-20">
        <img
          src="https://static.igem.wiki/teams/4260/wiki/collabs/collabs/partner.png"
          alt="partnership petri"
          className="m-auto"
          style={{ minWidth: 1400, maxWidth: 1400, width: 1400 }}
          useMap="#petri-map"
        />

        <map name="petri-map">
          <area
            target=""
            alt="CEM"
            title="CEM"
            onClick={() => {
              document.getElementById("cem_modal").click();
            }}
            coords="595,320,806,450"
            shape="rect"
          />
          <area
            target=""
            alt="CCM"
            title="CCM"
            onClick={() => {
              document.getElementById("ccm_modal").click();
            }}
            coords="350,219,557,327"
            shape="rect"
          />
          <area
            target=""
            alt="MTY"
            title="MTY"
            onClick={() => {
              document.getElementById("mty_modal").click();
            }}
            coords="310,449,553,555"
            shape="rect"
          />
          <area
            target=""
            alt="CHIHUAHUA"
            title="CHIHUAHUA"
            onClick={() => {
              document.getElementById("chihuahua_modal").click();
            }}
            coords="823,210,1032,318"
            shape="rect"
          />
          <area
            target=""
            alt="GUADALAJARA"
            title="GUADALAJARA"
            onClick={() => {
              document.getElementById("guadalajara_modal").click();
            }}
            coords="845,453,1091,559"
            shape="rect"
          />
          <area
            target=""
            alt="PATRAS"
            title="PATRAS"
            onClick={() => {
              document.getElementById("patras_modal").click();
            }}
            coords="352,658,595,767"
            shape="rect"
          />
          <area
            target=""
            alt="ABOA"
            title="ABOA"
            onClick={() => {
              document.getElementById("alboa_modal").click();
            }}
            coords="805,659,1051,768"
            shape="rect"
          />
          <area
            target=""
            alt="WORLD"
            title="WORLD"
            onClick={() => {
              document.getElementById("world_modal").click();
            }}
            coords="787,654,611,466"
            shape="rect"
          />
        </map>
      </div>
      <ModalGlass modalId="ccm_modal">
        <div className="text-white">
          <h3 className="h3">Tec-CCM 2022:</h3>
          <img
            src="https://static.igem.wiki/teams/4260/wiki/partnership-cem-ccm.jpeg"
            alt="partnership"
            className="figure"
            style={{ width: 400 }}
          />
          <p className="p">
            iGEM Tec-CCM was one of our most plausible partnerships, taking
            either wet-lab and dry-lab even further. In view of the fact that
            Tec-CCM lacked equipment for the developing and characterization of
            nanodevices, we synthesized and characterized functionalized gold
            nanoparticles (AuNPs). Quantum chemistry and computational
            calculations are a competent tool when predicting properties of a
            system such as binding forces and orbital energies. Thus, the iGEM
            TecCEM team developed calculations for their molecular system.
          </p>
          <p className="p">The way our projects were shaped at;</p>
          <ul className="list-disc pl-8">
            <li>
              Design stage: As mentioned, DFT calculations were helpful to know
              not only how achievable would the project be but how far it could
              get.
            </li>
            <li>
              Built stage was affected by achieving a complete characterization
              of nanoscale devices, with equipment such as electron and atomic
              force microscopes. These can be of great insight when knowing the
              properties of the phenomenon being observed. In this case, iGEM
              Tec-CEM provided a full overview on the synthesis of
              aptamer-functionalized gold nanoparticles.
            </li>
          </ul>
          <p className="p">
            We as a team believe that partnerships are about pushing each other
            forward, which was achieved during the sessions. Synthetic biology
            strategies were shared between the teams as well.
          </p>
        </div>
      </ModalGlass>
      <ModalGlass modalId="chihuahua_modal">
        <div className="text-white">
          <h3 className="h3">Tec-Chihuahua 2022:</h3>
          <img
            src="https://static.igem.wiki/teams/4260/wiki/partnership-cem-chh1.jpeg"
            alt="partnership"
            className="figure"
            style={{ width: 700 }}
          />
          <p className="p">
            iGEM TecCEM and Tec Chihuahua gathered several times to share
            project advances and receive helpful advice. This was a shaping
            partnership of our project due to the exchange of laboratory
            reagents between our teams.
          </p>
          <p className="p">The way our projects were shaped;</p>
          <ul className="list-disc pl-8">
            <li>
              Design stage were through assessment on molecular biology and
              genetic strategies, also in how to order sequences of genes in
              sponsorship platforms.
            </li>
            <li>
              Built stage; we were able to create and continue with our
              experiments thanks to the shipped reagents, biobrick parts, kits,
              plasmids, and E.coli strains between both teams. Finally, they
              shared polluted water from the lagoon of bustillos, Cuauhtémoc
              Chihuahua, Virgenes Dam, Rosales, Boquilla Dam, San Francisco de
              Conchos, El Rejon Dam, Chihuahua.
            </li>
          </ul>
          <p className="p">
            An effective team communication channel starting from Student Leader
            to student Leader. It was multiple times we helped each other with
            shipping and advising.
          </p>
          <img
            src="https://static.igem.wiki/teams/4260/wiki/partnership-cem-chh2.jpeg"
            alt="partnership"
            className="figure"
            style={{ width: 200 }}
          />
        </div>
      </ModalGlass>
      <ModalGlass modalId="guadalajara_modal">
        <div className="text-white">
          <h3 className="h3">Tec-Guadalajara 2022:</h3>
          <img
            src="https://static.igem.wiki/teams/4260/wiki/prtnership-gdl2.jpeg"
            alt="partnership"
            className="figure"
            style={{ width: 700 }}
          />
          <p className="p">
            TecCEM and Tec-Guadalajara gathered through the season seeking for
            the implementation of Tec-Guadalajara´s proposal of implementing an
            antibiotic collection box. It's worth mentioning that several drugs
            act as endocrine disruptors and the unconscious disposal of drugs
            increases pollution in bodies of water and the environment.
          </p>
          <p className="p">The way our projects were shaped;</p>
          <ul className="list-disc pl-8">
            <li>
              Design stage: through information and investigation exchange.
            </li>
            <li>
              Built stage; we created a strategy to talk with the principals in
              our campus to address the issue and point out the negative effects
              that the unconscious disposal of drugs generates both for the
              environment and for human health.
            </li>
          </ul>
          <p className="p">
            An effective team communication channel starting from Student Leader
            to student Leader, following up to establish the strategy.
          </p>
          <img
            src="https://static.igem.wiki/teams/4260/wiki/partnership-gdl.png"
            alt="partnership"
            className="figure"
            style={{ width: 700 }}
          />
          <p className="p">
            Fig 1. Sequence of steps to follow by TEC teams to implement a
            proposal for an antibiotic collection box in all of our campuses.
          </p>
        </div>
      </ModalGlass>
      <ModalGlass modalId="mty_modal">
        <div className="text-white">
          <h3 className="h3">Tec-Monterrey 2022:</h3>
          <img
            src="https://static.igem.wiki/teams/4260/wiki/partnership-cem-mty.png"
            alt="partnership"
            className="figure"
            style={{ width: 700 }}
          />
          <p className="p">
            TecCEM and Tec-Monterrey shared reactants such as plasmids. It
            included a mentorship from our PI on the matter.
          </p>
          <p className="p">The way our projects were shaped;</p>
          <ul className="list-disc pl-8">
            <li>
              Design stage: through information and investigation exchange.
            </li>
            <li>
              Built stage: the plasmid helped Monterrey team to clone it's
              constructs.
            </li>
          </ul>
          <p className="p">
            Communication channel starting from Student Leader to Student
            Leader.
          </p>
        </div>
      </ModalGlass>
      <ModalGlass modalId="patras_modal">
        <div className="text-white">
          <div className="text-white">
            <h3 className="h3">Patras 2022:</h3>
            <p className="p">
              iGEM Patras was the team with which we had the most contact
              throughout the competition, thus getting to know and carry out
              different activities that helped both the dissemination of our
              projects and its improvement by seeing the different areas of
              opportunity.
            </p>
            <p className="p">The way our projects were shaped;</p>
            <ul className="list-disc pl-8">
              <li>
                Design stage: through information and investigation exchange,
                where Patras give us valuable information about enzymes and we
                give them information on irrigation water regarding our tomato
                cultivation in the experimental field.
              </li>
              <li>
                Built stage: the making of a handbook with the development of
                our projects, explanation of the different pathogens that affect
                the crops of different countries and how to obtain a sustainable
                agriculture. Holding an international conference on water
                bioremediation to provide the public with more information on
                this topic and our projects, this also in collaboration with
                iGEM ASU.
              </li>
            </ul>
            <p className="p">
              Effective team communication channel from Student Leader to
              Student Leader. During the process we encouraged each other in the
              realization of our projects in the different sessions that we had.
            </p>
          </div>
        </div>
      </ModalGlass>
      <ModalGlass modalId="alboa_modal">
        <div className="text-white">
          <h3 className="h3">Aboa 2022:</h3>
          <p className="p">
            iGEM Aboa was present during the realization of our project by
            providing us with important information about different laccase
            enzymes to reaffirm the decision to use the laccase that would best
            work with the expected result in our project.
          </p>
          <p className="p">The way our projects were shaped;</p>
          <ul className="list-disc pl-8">
            <li>
              Design stage: through information and investigation exchange,
              especially on the information of the different types of laccase
              enzyme that we could use for our project.
            </li>
            <li>
              Built stage: the realization of a handbook with the development of
              our projects, explanation of the different pathogens that affect
              the crops of different countries and how to obtain a sustainable
              agriculture.
            </li>
          </ul>
          <p className="p">
            Effective team communication channel from Student Leader to Student
            Leader.
          </p>
        </div>
      </ModalGlass>
      <ModalGlass modalId="cem_modal">
        <div className="text-white">
          <h3 className="h3">Overview</h3>
          <p className="p">
            Instituto Tecnológico de Estudios Superiores Monterrey (TEC) has
            different campuses all over Mexico, we are independent teams that
            belong to the same institution but in different states of the
            republic. A partnership alliance was created where knowledge,
            advice, laboratory tools and experimentation was shared along this
            2022 year. TEC teams after meeting for the first time, talked about
            their projects and realized that we were all dealing with similar
            issues regarding agriculture or rural activities. That is why we
            decided to create our experimental and research support network. We
            all seek to implement beneficial, accessible, useful and safe
            resources and technologies within this sector. The teams that make
            up this network; TecCEM, Tec CCM, TecMonterrey_GDL, Tec Chihuahua
            and Tec-Monterrey.
          </p>
          <img
            src="https://static.igem.wiki/teams/4260/wiki/partenrship-tecs.png"
            alt="partnership"
            className="figure"
            style={{ width: 700 }}
          />
          <p className="p">Impact of rural activities in Mexico</p>
          <p className="p">
            Currently one of the greatest challenges that Mexico is facing,
            comes from rural activities related issues, those that pollute the
            resources used in agriculture, livestock and fishing examples. These
            activities represent 56.8%, 39.7% and 3.5% respectively of the GDP
            per capita, thus, the importance of looking for this sector´s
            development is stated [1].
          </p>
          <h3 className="h3">Our Aim:</h3>
          <ul className="list-disc pl-8">
            <li>
              Implement accessible resources and technologies for helping this
              sector since they have emerging problems such as low budget,
              limited resources, poorly distributed government support, etc.
            </li>
            <li>Shape our project</li>
            <li>Support between each team</li>
            <li>Increase communication between teams</li>
            <li>Create a synergy</li>
          </ul>
          <p className="p">
            All these help to develop this year's work for each team with a
            great outcome.
          </p>
          <p className="p">
            [1] Institutional Program 2013-2018 of the National Financial
            Secretariat for Agricultural, Rural, Forestry and Fisheries
            Development. Ministry of Finance and Public Credit, Mexico, D.F.,
            DOF, April 29, 2014. (Online) Available at
            https://www.dof.gob.mx/nota_detalle_popup.php?codigo=5343084
          </p>
        </div>
      </ModalGlass>
      <ModalGlass modalId="world_modal">
        <div className="text-white">
          <h3 className="h3"> Partnership with Patras and Aboa in iGem 2022</h3>
          <p className="p">
            Agriculture is an economic activity of great importance in Mexico,
            but this also applies to different countries, two of them are Greece
            and Finland, of which it stands out that at least 10% of its
            population is involved in primary agricultural production.
          </p>
          <p className="p">
            After various meetings to discuss our projects together, it was
            decided to create an alliance where we would share knowledge and
            important data that would be useful for our respective jobs.
          </p>
          <p className="p">
            After various meetings to discuss our projects together, it was
            decided to create an alliance where we would share knowledge and
            important data that would be useful for our respective jobs.
          </p>
          <p className="p">Our aim</p>
          <ul className="list-disc pl-8">
            <li>
              Implement accessible resources and technologies for helping this
              sector since they have emerging problems such as low budget,
              limited resources, poorly distributed government support, etc.
            </li>
            <li>Shape our project</li>
            <li>Support between international teams</li>
            <li>Increase communication between teams</li>
            <li>Increase communication between teams</li>
          </ul>
          <p className="p">
            All these help to develop this year's work for each team with a
            great outcome.
          </p>
          <img
            src="https://static.igem.wiki/teams/4260/wiki/ods.jpeg"
            alt="ODS"
            className="figure"
          />
        </div>
      </ModalGlass>
    </div>
  );
}
